export enum ReceiptType {
  Investment = 1,
  Wallet = 2,
  OnboardingFee = 3,
}
